import './Nav.css';

function MobileNav({ updateMobileNavStatus }) {
  return (
    <div className="mobile-nav-box">
      <div className="sticky-view">
        <span className="close-icon" onClick={ updateMobileNavStatus }>
          <svg viewBox="0 0 20 20" 
            fill="currentColor" 
            stroke="currentColor" 
            strokeWidth="1.5" 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            aria-hidden="true">
            <path d="M15.898,4.045c-0.271-0.272-0.713-0.272-0.986,0l-4.71,4.711L5.493,4.045c-0.272-0.272-0.714-0.272-0.986,0s-0.272,0.714,0,0.986l4.709,4.711l-4.71,4.711c-0.272,0.271-0.272,0.713,0,0.986c0.136,0.136,0.314,0.203,0.492,0.203c0.179,0,0.357-0.067,0.493-0.203l4.711-4.711l4.71,4.711c0.137,0.136,0.314,0.203,0.494,0.203c0.178,0,0.355-0.067,0.492-0.203c0.273-0.273,0.273-0.715,0-0.986l-4.711-4.711l4.711-4.711C16.172,4.759,16.172,4.317,15.898,4.045z" />
          </svg>
        </span>

        <ul className="mobile-nav-list">
          <li className="mobile-nav-item mobile-nav-about mobile-selected-nav-item">
            <a href="#about" onClick={ updateMobileNavStatus }>
              <span className="mobile-nav-item-dot" />
              <span className="mobile-nav-item-title">About</span>
            </a>
          </li>
          <li className="mobile-nav-item mobile-nav-experience">
            <a href="#experience" onClick={ updateMobileNavStatus }>
              <span className="mobile-nav-item-dot" />
              <span className="mobile-nav-item-experience">Experience</span>
            </a>
          </li>
          <li className="mobile-nav-item mobile-nav-projects">
            <a href="#projects" onClick={ updateMobileNavStatus }>
              <span className="mobile-nav-item-dot" />
              <span className="mobile-nav-item-projects">Projects</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default MobileNav;